import React, { useEffect, useState } from "react";
import { Row, Col, Container, Button } from "react-bootstrap";
import "./AddFund.css";
import apiCall from "./../../API/API";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AddFunds = () => {
  const [userName, setUserName] = useState("");
  const [amount, setAmount] = useState("");
  const [fundReason, setFundReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [existUserName, setExistUserName] = useState();
  const token = localStorage.getItem("authToken");
  const [is2faEnabled, setIs2faEnabled] = useState(false);
  const [incomeData, setIncomeData] = useState();
  const [otp, setOtp] = useState("");
  const [selectWallet, setSelectWallet] = useState();

  useEffect(() => {
    const check2FAStatus = async () => {
      // setLoading(true);
      try {
        const { data, error: apiError } = await apiCall(
          "GET",
          "/check_2fa_status"
        ); // Assuming an endpoint to check 2FA status
        if (apiError) {
          toast.error(apiError.message || "Failed to fetch 2FA status.");
        } else if (data && typeof data.isEnabled === "boolean") {
          console.log("status---------999", data);
          setIs2faEnabled(data.isEnabled);
        }
      } catch (err) {
        toast.error("An error occurred while fetching 2FA status.");
        console.error("2FA Status Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };
    check2FAStatus();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // if (!userName || !amount) {
    //   toast.error("Please fill in all fields");
    //   return;
    // }

    const requestBody = {
      amount: amount,
      username: userName,
      wallet_name: selectWallet,
      note: "Fund added by admin",
    };

    if (is2faEnabled) {
      requestBody.token = otp;
    }
    console.log("post data", requestBody);
    // return;

    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: token,
        },
      };
      const { data, error } = await apiCall(
        "post",
        "/add_fund",
        requestBody,
        config
      );

      if (data) {
        // toast.success(data?.message || "");
        setUserName("");
        setAmount("");
        setFundReason("");
        setOtp("");
      } else if (error) {
        // toast.error(error.message || "An error occurred");
      }
    } catch (error) {
      toast.error(error.message || "An error occurred");
    } finally {
      setLoading(false);
    }
  };
  const isUserExist = async () => {
    setLoading(true);

    if (!userName) {
      setExistUserName(". . .");
      setLoading(false);
      return;
    }

    try {
      const { data, error } = await apiCall("post", "/check_username", {
        username: userName,
      });
      if (data) {
        setExistUserName(data.name);
      } else if (error) {
        setExistUserName("User not exists");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    }
    setLoading(false);
  };

  useEffect(() => {
    // Clear the timeout when the user is typing
    if (typingTimeout) {
      clearTimeout(typingTimeout);
    }

    // Set a new timeout to call the API after the user stops typing
    setTypingTimeout(
      setTimeout(() => {
        isUserExist();
      }, 1000) // 500ms debounce delay
    );

    // Cleanup the timeout when the component is unmounted or when typing continues
    return () => clearTimeout(typingTimeout);
  }, [userName]);

  const fetchWallets = async (e) => {
    try {
      const { data, error } = await apiCall("get", "/retrieve_wallet");
      console.log("dataaaaa................", data);
      setIncomeData(data?.data);
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };

  var x = 0;

  useEffect(() => {
    if (x == 0) {
      fetchWallets();
      x++;
    }
  }, []);

  return (
    <React.Fragment>
      <Container className="mt-4">
        <section id="add-funds-section">
          <div className="d-flex justify-content-center">
            <h2>Add Funds</h2>
          </div>
          <section id="formContent">
            <div className="form">
              <Row>
                <Col lg={6} style={{ margin: "auto" }}>
                  <form onSubmit={handleSubmit}>
                    <div id="formFields">
                      <div className="mb-3">
                        <div className="d-flex">
                          <label htmlFor="userName">
                            User Name:{" "}
                            {/* {existUserName && (
                              <span
                                style={{ marginLeft: "8px", color: "green" }}
                              >
                                {existUserName}
                              </span>
                            )} */}
                          </label>
                          {/* <label style={{ textAlign: "end" }}>
                            Fund Wallet
                          </label> */}
                          {existUserName && (
                            <label
                              style={{ textAlign: "end", color: "green" }}
                              htmlFor="userName"
                            >
                              {loading && userName
                                ? "Loading..."
                                : existUserName}
                            </label>
                          )}
                        </div>
                        <input
                          type="text"
                          id="userName"
                          className="form-control"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          placeholder="Enter your Username"
                          required
                        />
                      </div>

                      <div className="mb-3">
                        <label htmlFor="choosebank">Select Wallet Type</label>
                        <select
                          className="selectBox"
                          name=""
                          id=""
                          value={selectWallet}
                          onChange={(e) => setSelectWallet(e.target.value)}
                        >
                          <option value="default">--Select Type--</option>
                          {Array.isArray(incomeData) &&
                            incomeData?.map((x, i) => {
                              return (
                                <option value={x?.wallet_name}>
                                  {x?.wallet_name
                                    .split("_") // Split the text by underscore
                                    .map((word, index) =>
                                      index === 0
                                        ? word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                        : word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                    )
                                    .join(" ")}
                                </option>
                              );
                            })}
                        </select>
                      </div>

                      <div className="mb-3">
                        <label htmlFor="amount">Amount:</label>
                        <input
                          type="number"
                          id="amount"
                          className="form-control"
                          value={amount}
                          onChange={(e) => setAmount(e.target.value)}
                          placeholder="Enter Amount"
                          required
                        />
                      </div>
                      {is2faEnabled && (
                        <div className="mb-3">
                          <label htmlFor="otp">Enter OTP:</label>
                          <input
                            type="text"
                            id="otp"
                            className="form-control"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            placeholder="Enter OTP from your Authenticator App"
                            required
                          />
                        </div>
                      )}
                      {/* <div className="mb-3">
                        <label>Note:</label>
                        <input
                          type="text"
                          placeholder="Note for adding Fund"
                          value={fundReason}
                          onChange={(e) => setFundReason(e.target.value)}
                          className=""
                          required
                        />
                      </div> */}
                      <Button
                        type="submit"
                        variant="primary"
                        disabled={
                          loading ||
                          !userName ||
                          existUserName === "User not exists" ||
                          existUserName === ". . ."
                        }
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                      <Button
                        variant="secondary"
                        className="ms-2"
                        onClick={() => {
                          setUserName("");
                          setAmount("");
                          setFundReason("");
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </Col>
              </Row>
            </div>
          </section>
        </section>
        {/* <ToastContainer className="toast-container" /> */}
      </Container>
    </React.Fragment>
  );
};

export default AddFunds;
